export default "__VITE_ASSET__BjzgQury__"